<template>
  <MainLayout>
    <div>
      <el-card class="management-container">
        <el-button
          type="primary"
          size="small"
          style="margin-bottom: 0.625em"
          @click="newLayerWMS"
        >
          New layer WMS
        </el-button>
        <el-table
          v-loading="layerWMSLoading"
          :data="layerWMSTableData"
          style="width: 100%"
        >
          <el-table-column prop="title" label="Layer Title" />
          <el-table-column prop="name" label="Layer Name" />
          <el-table-column prop="url" label="Url" />
          <el-table-column width="80" label="Edit">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="editLayerWMS(scope.row)"
                icon="el-icon-edit"
              />
            </template>
          </el-table-column>
          <el-table-column width="80" label="Delete">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                style="margin-left: 0.625em;"
                @click="deleteLayerWMS(scope.row)"
                icon="el-icon-delete"
              />
            </template>
          </el-table-column>
        </el-table>
      </el-card>

      <el-dialog
        :title="currentLayerWMS ? 'Update' : 'Create New' + ' Layer WMS'"
        :visible.sync="editLayerWMSDialog"
        width="50%"
        :modal="false"
      >
        <el-form
          ref="edit-layerWMS-form"
          :model="editLayerWMSForm"
          :rules="currentLayerWMS ? {} : editLayerWMSRules"
          label-width="8.75em"
        >
          <!-- title -->
          <el-form-item
            label="Title"
            prop="title"
            :error="editLayerWMSErrors['title']"
          >
            <el-input v-model="editLayerWMSForm.title" />
          </el-form-item>
          <!-- Name -->
          <el-form-item
            label="Layer Name"
            prop="name"
            :error="editLayerWMSErrors['name']"
          >
            <el-input v-model="editLayerWMSForm.name" />
          </el-form-item>
          <!-- url -->
          <el-form-item
            label="Url"
            prop="url"
            :error="editLayerWMSErrors['url']"
          >
            <el-input v-model="editLayerWMSForm.url" />
          </el-form-item>
          <el-form-item
            label="Pane"
            prop="pane"
            :error="editLayerWMSErrors['pane']"
          >
            <el-input v-model="editLayerWMSForm.pane" />
          </el-form-item>
          <el-form-item
            label="Format"
            prop="format"
            :error="editLayerWMSErrors['format']"
          >
            <el-input v-model="editLayerWMSForm.format" />
          </el-form-item>
          <el-form-item
            label="Max Zoom"
            prop="max_zoom"
            :error="editLayerWMSErrors['max_zoom']"
          >
            <el-input v-model="editLayerWMSForm.max_zoom" />
          </el-form-item>
          <el-form-item
            label="Attribution"
            prop="attribution"
            :error="editLayerWMSErrors['attribution']"
          >
            <el-input v-model="editLayerWMSForm.attribution" />
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="editLayerWMSDialog = false">Cancel</el-button>
          <el-button
            :loading="editLayerWMSLoading"
            type="primary"
            @click="submitLayerWMSForm('edit-layerWMS-form')"
          >
            {{ currentLayerWMS ? "Update" : "Create" }}
          </el-button>
        </span>
      </el-dialog>
    </div>
  </MainLayout>
</template>

<script>
import api from "@/api";

export default {
  metaInfo: {
    title: "Layers",
    meta: [{ name: "Layers", content: "layers management" }]
  },

  data() {
    return {
      layerWMSLoading: false,
      layerWMSTableData: [],
      createLayerWMSDialog: false,
      createLayerWMSLoading: false,
      createPropertyRuleDialog: false,
      createLayerWMSForm: {},
      editLayerWMSDialog: false,
      editLayerWMSLoading: false,
      editLayerWMSForm: {
        name: "",
        title: undefined,
        url: undefined,
        pane: null,
        format: null,
        max_zoom: null,
        attribution: null
      },
      currentLayerWMS: {},
      editLayerWMSRules: {
        name: [
          {
            required: true,
            message: "Please input Layer WMS name",
            trigger: "blur"
          }
        ],
        title: [
          {
            required: true,
            message: "Please input Layer WMS title",
            trigger: "blur"
          }
        ],
        url: [
          {
            required: true,
            message: "Please input Layer WMS url",
            trigger: "blur"
          }
        ]
      },
      editLayerWMSErrors: {}
    };
  },
  methods: {
    fetchlayersWMS() {
      try {
        this.layerWMSLoading = true;
        api
          .getLayers()
          .then(res => {
            this.layerWMSTableData = res.data.data;
            this.layerWMSLoading = false;
          })
          .catch(e => {
            this.layerWMSLoading = false;
            console.log(e);
          });
      } catch (err) {
        this.$notify.error(err.message);
      } finally {
        this.layerWMSLoading = false;
      }
    },
    validateForm(formName) {
      this.$refs[formName].validate();
    },

    submitLayerWMSForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.currentLayerWMS) {
            this.updateLayerWMS();
          } else {
            this.createLayerWMS();
          }
        }
      });
    },
    newLayerWMS() {
      this.currentLayerWMS = undefined;
      this.editLayerWMSForm = {
        name: "",
        title: undefined,
        url: undefined,
        pane: null,
        format: null,
        max_zoom: null,
        attribution: null
      };
      this.editLayerWMSDialog = true;
    },

    editLayerWMS(layer) {
      this.currentLayerWMS = layer;
      this.editLayerWMSForm = {
        ...layer
      };
      this.editLayerWMSDialog = true;
    },

    createLayerWMS() {
      try {
        this.editLayerWMSLoading = true;
        this.editLayerWMSErrors = {};
        api
          .addLayer(this.editLayerWMSForm)
          .then(() => {
            this.editLayerWMSLoading = false;
            this.$notify.success("The layer has been created");
            this.fetchlayersWMS();
            this.editLayerWMSDialog = false;
          })
          .catch(e => {
            console.error(e);

            if (e.status_code === 422) {
              this.errors = e.errors;
            } else {
              this.$notify.error(e.message);
            }
          });
      } catch (err) {
        this.editLayerWMSLoading = false;
        const msg = this.getErrorMessage(err);

        if (msg instanceof Object) {
          this.editDetectionErrors = msg;
        } else {
          this.$notify.error(msg);
        }
      }
    },

    updateLayerWMS() {
      try {
        this.editLayerWMSLoading = true;
        this.editLayerWMSErrors = {};
        api
          .updateLayer(this.currentLayerWMS.id, this.editLayerWMSForm)
          .then(() => {
            this.editLayerWMSLoading = false;
            this.editLayerWMSDialog = false;
            this.$notify.success("The layer has been updated");
            this.fetchlayersWMS();
          })
          .catch(e => {
            console.error(e);

            if (e.status_code === 422) {
              this.errors = e.errors;
            } else {
              this.$notify.error(e.message);
            }
          });
      } catch (err) {
        this.editLayerWMSLoading = false;
        const msg = this.getErrorMessage(err);

        if (msg instanceof Object) {
          this.editDetectionErrors = msg;
        } else {
          this.$notify.error(msg);
        }
      }
    },
    async deleteLayerWMS(layer) {
      try {
        await this.$confirm(
          "This will permanently delete the layer. Continue?",
          "Warning",
          {
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            type: "warning"
          }
        );

        this.layerWMSLoading = true;

        api
          .deleteLayer(layer.id)
          .then(() => {
            this.layerWMSLoading = false;
            this.$notify.success("The layer has been deleted");
            this.fetchlayersWMS();
          })
          .catch(e => {
            console.error(e);

            if (e.status_code === 422) {
              this.errors = e.errors;
            } else {
              this.$notify.error(e.message);
            }
          });

        this.currentLayerWMS = undefined;
      } catch (err) {
        this.$notify.error(err.message);
      } finally {
        this.layerWMSLoading = false;
      }
    },
    getErrorMessage(error) {
      if (error.response) {
        const resData = error.response.data;
        if (resData.status_code === 422) {
          return Object.keys(resData.errors).reduce((errors, prop) => {
            errors[prop] = resData.errors[prop].join(", ");
            return errors;
          }, {});
        }

        return resData.message;
      } else {
        return error.message;
      }
    }
  },
  mounted() {
    this.fetchlayersWMS();
  }
};
</script>

<style lang="css" scoped>
.form-item-view {
  display: flex;
  width: 100%;
  align-items: center;
}
.form-item-label {
  width: 10em;
  text-align: right;
  margin-right: 1.25em;
  margin-bottom: 1.25em;
}
</style>
